import { DocumentDesignEditor } from "./DocumentDesignEditor";

interface HeaderZoneProps {
  value: string;
  onChange: (next: string) => void;
}

export function HeaderZone({ value, onChange }: HeaderZoneProps) {
  return (
    <DocumentDesignEditor
      value={value}
      onChange={onChange}
      height={300}
      uploadType="header"
    />
  );
}
